import { LogoutPage } from 'pages/Logout';
import { appRouterPaths } from 'services/navigation';
import type { AppRouteProps } from '../types';

export const logoutPageRoute: AppRouteProps = {
  path: appRouterPaths.logout,
  element: <LogoutPage />,
};
